function darkModeModule() {
    (fancybox = null),
        (dark_mode = false),
        (this.init = function () {
            var _this = this;

            this.fancybox = $.HSCore.components.HSFancyBox.init(
                $(".js-fancybox-garden"),
                {
                    afterShow: function () {
                        if (_this.dark_mode) {
                            _this.imageToSource("data-src-night-mode");
                        } else {
                            _this.imageToSource("data-src-original");
                        }
                        setTimeout(function () {
                            $(".fancybox-loader").fadeOut();
                        }, 300);
                    },
                }
            );

            $("[data-dark-mode]").on("click", function (e) {
                e.preventDefault();

                var show_hide = dark_mode ? "hide" : "";
                dark_mode = !dark_mode;

                if (show_hide == "hide") {
                    _this.disableDarkMode();
                } else {
                    _this.activateDarkMode();
                }
            });
        }),
        (this.activateDarkMode = function () {
            this.dark_mode = true;

            Livewire.dispatch("activateDarkMode");

            $("body").addClass("dark-mode");
            $("[data-dark-mode]")
                .css({
                    background: "#353535",
                })
                .find("span.icon-container")
                .html(
                    '<i class="fas mr-2 fa-cloud-sun" style="color:yellow;"></i>'
                );
            $("[data-dark-mode]")
                .find("span.text")
                .html('<span style="color:#a2a26e">Zet verlichting uit</span>');

            if (this.darkModeVideoAvailable()) {
                $(".video-by-night").removeClass("d-none");
                $(".video-by-day").addClass("d-none");
            }

            this.imageToSource("data-src-night-mode");
        }),
        (this.disableDarkMode = function () {
            this.dark_mode = false;

            Livewire.dispatch("disableDarkMode");

            $("[data-dark-mode]")
                .css({
                    background: "inherit",
                })
                .find("span.icon-container")
                .html('<i class="fas mr-2 fa-cloud-sun"></i>');
            $("[data-dark-mode]").find("span.text").html("Zet verlichting aan");

            $("body").removeClass("dark-mode");

            if (this.darkModeVideoAvailable()) {
                $(".video-by-night").addClass("d-none");
                $(".video-by-day").removeClass("d-none");
            }

            this.imageToSource("data-src-original");
        }),
        (this.imageToSource = function (data_source_attr) {
            var _this = this;

            $("[data-src-night-mode]").each(function () {
                var $element = $(this);
                var night_mode_image = $element.attr(data_source_attr);
                if (night_mode_image) {
                    if (_this.dark_mode == true) {
                        var current_source = $element.attr("data-src-original");
                    } else {
                        var current_source = $element.attr(
                            "data-src-night-mode"
                        );
                    }

                    $element.attr("src", night_mode_image);
                    $element.attr("data-src", night_mode_image);
                    $('img[src="' + current_source + '"]').attr(
                        "src",
                        night_mode_image
                    );

                    // console.log(current_source + ' to ' + night_mode_image);
                }
            });
        }),
        (this.darkModeVideoAvailable = function () {
            return $(".video-by-night").length;
        });
}

module.exports = darkModeModule;
